import styled from "styled-components";

export const StoryCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;

  width: 100%;
  max-width: 1170px;

  gap: 32px;
  margin: 0 auto 120px;

  position: relative;
  cursor: pointer;
  overflow: auto;

  @media (max-width: 900px) {
    gap: 16px;

    overflow: auto;
  }
`;
